import {
  SUPPLY_ORDER_RECEIPT_TABLE_TEXTS as RECEIPT_TEXTS,
} from '../constants/supplyOrdersConstants';
import { formatSupplyOrderQuantity } from './supplyOrdersUtils';

/**
 * Resume las cantidades recibidas de una recepción ("10 u., 5 u.").
 * @param {Array<Object>} [items] Renglones de la recepción con `received_quantity`.
 * @returns {string} Cantidades separadas por coma, o "-" si no hay renglones.
 */
export const formatSupplyOrderReceiptItems = (items = []) =>
  items
    .map((item) => {
      const quantity = formatSupplyOrderQuantity(item.received_quantity);
      return `${quantity} ${RECEIPT_TEXTS.unitSuffix}`;
    })
    .join(', ') || '-';
